export enum DialogMemberType {
  Client = 1,
  Admin = 2,
  Bot = 3,
}
